import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";
import { Helper } from "src/app/core/helpers/helper";

@Injectable({
  providedIn: "root"
})
export class CountryService {
  constructor(private apiService: ApiService, private helper: Helper) {}

  /** Returns every country in the system (no business filtering). Mirrors user-panel. */
  getAllCountryList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.allCountryList, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getCountryList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.country, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            if (this.helper.dispatcherDetails?.entity?.countryCode) {
              // Extract userCountryCode, defaulting to an empty string if undefined or null
              const userCountryCode = this.helper.dispatcherDetails?.entity?.countryCode ?? "";
              // Find the first country where code or alpha2 matches the userCountryCode
              this.helper.userCountryPhoneCodeList = response.data.data.countries?.find(
                (country: any) => country.code === userCountryCode || country.code2 === userCountryCode
              ).phoneCodes;
            }
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getCountryDetails(countryId: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.country}/${countryId}`;
      this.apiService.get({ url: url, parameters: {} }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getCountryCityList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.countryCityBoth, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
